module.exports = __webpack_public_path__ + "img/completed.1219cf2d.svg";